import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    editProject: {
        code: {
            value: "",
            error: "",
            showError: "",
        },
        projectName: {
            value: "",
            error: "",
            showError: "",
        },
        street: {
            value: "",
            error: "",
            showError: "",
        },
        projectState: {
            value: "",
            error: "",
            showError: "",
        },
        city: {
            value: "",
            error: "",
            showError: "",
        },
        zipcode: {
            value: "",
            error: "",
            showError: "",
        },
        owner: {
            value: [],
            error: "",
            showError: "",
        },
        foremen: {
            value: [],
            error: "",
            showError: "",
        },
    },
}

const editProject = createNamespacer("EDIT_PROJECT")

export const editProjectReducer = createReducer(initialState.editProject, {
    [editProject("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [editProject("SET_PROJECT_CODE")]: (state, action) => {
        return {
            ...state,
            code: {
                ...state.code,
                value: action.payload.value,
            },
        }
    },
    [editProject("SET_PROJECT_NAME")]: (state, action) => {
        return {
            ...state,
            projectName: {
                ...state.projectName,
                value: action.payload.value,
            },

        }
    },
    [editProject("SET_STREET")]: (state, action) => {
        return {
            ...state,
            street: {
                ...state.street,
                value: action.payload.value,
            },
        }

    },
    [editProject("SET_CITY")]: (state, action) => {
        return {
            ...state,
            city: {
                ...state.city,
                value: action.payload.value,
            },
        }
    },
    [editProject("SET_STATE")]: (state, action) => {
        return {
            ...state,
            projectState: {
                ...state.projectState,
                value: action.payload.value,
            },
        }
    },
    [editProject("SET_ZIPCODE")]: (state, action) => {
        return {
            ...state,
            zipcode: {
                ...state.zipcode,
                value: action.payload.value,
            },

        }
    },
    [editProject("SET_OWNER")]: (state, action) => {
        return {
            ...state,
            owner: {
                ...state.owner,
                value: action.payload.value
            },
        }
    },
    [editProject("SET_FOREMEN")]: (state, action) => {
        return {
            ...state,
            foremen: {
                ...state.foremen,
                value: action.payload.value
            },
        }
    },
    [editProject("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            code: 'code',
            projectName: 'name',
            street: 'street',
            city: 'city',
            projectState: 'state',
            zipcode: 'zipcode',
        }

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey] || ""
                }]
            })
        )

        let foremenList = action.payload.value.foremen.map((foremen) => {
            return {
                value: foremen.value,
                label: foremen.label,
                id: foremen.id,
            }
        })

        let ownerList = action.payload.value.owners.map((owner) => {
            return {
                value: owner.value,
                label: owner.label,
                id: owner.id,
            }
        })

        let newLoadedList = {
            ...loadedFields,
            foremen: {
                ...state.foremen,
                value: foremenList
            },
            owner: {
                ...state.owner,
                value: ownerList
            }
        }

        return {
            ...state,
            ...newLoadedList,
        }

    },
    [editProject("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }

    },
    [editProject("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.editProject,
        }
    },
})